import MultiSelectBox from './MultiSelectBox';
import './MultiSelectBox.scss';

export default MultiSelectBox;